export default "<!-- Silence -->"